import {login, loginOut, refreshToken, updateUserInfo} from "@/api/auth";
import {isBlank} from "@/utils/fun";
import {get, keys, remove, set, update} from "@/utils/storage"
import router from "@/router";
import {success} from "@/utils/elMessage";

const state = {
    // 用户详情
    userInfo: null,
    // token
    token: null,
    // 刷新token
    refreshToken: null,
    // 是否登录
    isLogin: false
}
const mutations = {
    // 登录设置
    SET_LOGIN(state, res) {
        const userInfo = {
            nickName: res.nickName,
            account: res.account,
            level: res.level,
            avatar: res.avatar,
            birthday: res.birthday
        }
        state.userInfo = userInfo
        state.token = res.token
        state.refreshToken = res.refreshToken
        state.isLogin = !isBlank(res.token) && !isBlank(res.refreshToken)
        set(keys.userInfo, userInfo, 60 * 60 * 2)
        set(keys.token, res.token, 60 * 60 * 2)
        set(keys.refreshToken, res.refreshToken, 60 * 60 * 24)
    },
    // 用户详情
    SET_USER_INFO(state, userInfo) {
        state.userInfo = userInfo
    },
    // token
    SET_TOKEN(state, token) {
        state.token = token
    },
    // 刷新token
    SET_REFRESH_TOKEN(state, refreshToken) {
        state.refreshToken = refreshToken
    },
    // 设置是否登录
    SET_IS_LOGIN(state, isLogin) {
        state.isLogin = isLogin
    }
}
const clearLoginState = (commit) => {
    commit('SET_USER_INFO', null)
    commit('SET_TOKEN', null)
    commit('SET_REFRESH_TOKEN', null)
    commit('SET_IS_LOGIN', false)
    remove(keys.userInfo)
    remove(keys.token)
    remove(keys.refreshToken)
}

const actions = {
    // 登录
    async USER_LOGIN({commit}, data) {
        await login(data)
            .then(res => {
                commit('SET_LOGIN', res)
                success('登录成功，跳转到首页面')
                // 跳转
                router.push({path: '/'}).then(_ => {
                }).catch(_ => {
                })
            }).catch(_ => {
            })
    },
    // 刷新用户数据
    async INIT_USER({commit}) {
        const token = get(keys.token)
        const refreshToken = get(keys.refreshToken)
        if (token == null && refreshToken == null) {
            clearLoginState(commit)
            return
        }
        commit('SET_TOKEN', token)
        commit('SET_REFRESH_TOKEN', refreshToken)
        commit('SET_IS_LOGIN', true)
        commit('SET_USER_INFO', get(keys.userInfo))
        await updateUserInfo()
            .then(res => {
                const userInfo = {
                    nickName: res.nickName,
                    account: res.account,
                    level: res.level,
                    avatar: res.avatar,
                    birthday: res.birthday
                }
                commit('SET_USER_INFO', userInfo)
                update(keys.userInfo, userInfo)

            }).catch(_ => {
            })
    },
    // 刷新token
    async REFRESH_TOKEN({commit}) {
        try {
            const res = await refreshToken();
            commit('SET_LOGIN', res)
            return res
        } catch (error) {
            return Promise.reject(new Error('请先登录~'));
        }
    },
    // 登录退出
    async LOGIN_OUT({commit}) {
        try {
            // 先通知后端删除 Redis token / refreshToken / perms，并写退出日志。
            await loginOut()
        } catch (_) {
            // 后端异常、token 过期或网络异常时，前端也必须清理本地登录状态，避免卡在系统内。
        } finally {
            clearLoginState(commit)
        }
    }
}
const getters = {
    // 用户详情
    userInfo: state => state.userInfo,
    // token
    token: state => state.token,
    // 刷新token
    refreshToken: state => state.refreshToken,
    // 是否登录
    isLogin: state => state.isLogin
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
